import { AxiosError, AxiosInstance } from "axios";
import * as Sentry from "@sentry/react";

/** Adds Sentry interceptor. It decides if error is meaningful and if it is, it will be sent to Sentry */
export function setupSentryInterceptor(axios: AxiosInstance) {
  axios.interceptors.response.use(
    (resp) => resp,
    (err: AxiosError) => {
      const statusCode = err.response?.status || 0;

      if (
        statusCode >= 500 ||
        statusCode === 400 ||
        statusCode === 403 ||
        statusCode === 409 ||
        statusCode === 422
      ) {
        logFailedRequest(err);
      }

      return Promise.reject(err);
    }
  );
}

const logFailedRequest = (resp: AxiosError) => {
  const statusCode = resp.response?.status || parseInt(resp.code || "");
  const url = resp.response?.config.url || "Unknown";

  Sentry.withScope((scope) => {
    if (resp.config?.headers) {
      scope.setTags({
        status: statusCode,
        requestId: resp.config.headers["X-Request-Id"] || "",
        sessionId: resp.config.headers["X-Session-Id"] || "",
      });

      if (resp.response?.data) {
        scope.setContext("Response", {
          response: JSON.stringify(resp.response.data),
        });
      }

      resp.name = `API Error (${statusCode}) - ${url}`.trim();
      Sentry.captureException(resp);
    }
  });
};
